var _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPlaceholderCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#2bb7d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.913 31.412l3.478-6.941C30.612 22.645 32.411 21 34.61 21H52c2.198 0 3.997 1.645 5.217 3.47l5.218 6.942h18.608c5.218 0 6.957 2.356 6.957 5.98v36.052C88 77.064 86.26 80 80.849 80H19.15C13.74 80 12 77.064 12 73.444V37.392c0-3.624 1.74-5.98 7.151-5.98z",
    strokeLinejoin: "round",
    strokeWidth: 4.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.512 30.833v-3.277m2.79 16.388h-6.046",
    strokeLinecap: "square",
    strokeWidth: 5.58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 54c0 9.94 8.06 18 18 18 9.943 0 18-8.06 18-18 0-9.943-8.057-18-18-18-9.94 0-18 8.057-18 18zm18-10c-5.52 0-10 4.477-10 10",
    strokeLinejoin: "round",
    strokeWidth: 4.375
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderCamera);
export default __webpack_public_path__ + "static/media/placeholder-camera.00723684ff61d0bee41b2d6ac466e970.svg";
export { ForwardRef as ReactComponent };